/**
 * Owner: Masa Bayu
 * File: shell-update.ts
 * Date:Time: 2026-09-22 06:02
 * Description: PWA-Phase-A Plane S — shell update orchestration · ≠ publication tip.
 */

export const PWA_SKIP_WAITING_MESSAGE = Object.freeze({ type: 'SKIP_WAITING' as const });

export type PwaShellUpdateState =
  | 'current'
  | 'update_available'
  | 'updating'
  | 'recovered'
  | 'failed';

export interface PwaShellUpdateView {
  readonly state: PwaShellUpdateState;
  readonly title: string;
  readonly body: string;
}

export function describeShellUpdateState(state: PwaShellUpdateState): PwaShellUpdateView {
  if (state === 'update_available') {
    return Object.freeze({
      state,
      title: 'App update available',
      body: 'Improves the app shell — not your books’ rights or library entitlement.',
    });
  }
  if (state === 'updating') {
    return Object.freeze({
      state,
      title: 'Updating app…',
      body: 'Applying the new shell version.',
    });
  }
  if (state === 'failed') {
    return Object.freeze({
      state,
      title: 'Still on previous app version',
      body: 'App update failed. Your publications and access are unchanged.',
    });
  }
  if (state === 'recovered') {
    return Object.freeze({
      state,
      title: 'App updated',
      body: 'You are on the latest app shell.',
    });
  }
  return Object.freeze({
    state: 'current',
    title: 'App up to date',
    body: 'Shell is current.',
  });
}

export async function promptWaitingWorkerToActivate(
  registration: {
    readonly waiting: { readonly postMessage: (message: unknown) => void } | null;
  } | null,
): Promise<boolean> {
  if (registration === null || registration.waiting === null) {
    return false;
  }
  registration.waiting.postMessage(PWA_SKIP_WAITING_MESSAGE);
  return true;
}
